
import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { IGoogleMapsMarker } from "@interfaces/IGoogleMapsMarkerOptions";
import * as angular from "angular";
import { IPolyline, IPolylineOptions } from "@typings/google.maps.angular";
import { IPlannedRouteVisit } from "../../../../main/modules/tms/_models/IPlannedRouteVisit";
import { IPlannedRoute } from "src/app/main/modules/tms/_models/IPlannedRoute";
import { IUnplannedStop } from "src/app/main/modules/tms/_models/IUnplannedStop";
import { SchedulingService } from "src/app/main/modules/tms/_services/scheduling.service";
import { PlannedRouteMapService } from "src/app/main/modules/tms/_services/planned-route-map.service";
import { IJourney } from "@interfaces/IJourney";

interface IVeriMapRouteBindings {

    veriMap: IVeriMapComponent;

    route: IPlannedRoute;
    scheduleMode?: boolean;
    unplannedStops: IUnplannedStop[];
    selectedVisit: IPlannedRouteVisit;
    markers: IGoogleMapsMarker<IPlannedRouteVisit>[];

    fit: boolean;
}

class VeriMapRouteComponentController implements angular.IComponentController, IVeriMapRouteBindings {

    veriMap: IVeriMapComponent;

    route: IPlannedRoute;
    scheduleMode: boolean;
    actualJourneys: IJourney[];
    unplannedStops: IUnplannedStop[];
    selectedVisit: IPlannedRouteVisit;
    routeVisits: IPlannedRouteVisit[];

    markers: IGoogleMapsMarker<IPlannedRouteVisit>[] = [];

    showPlannedRoute: boolean;
    showActualRoute: boolean;
    showUnplannedStops: boolean;

    fit: boolean;

    polylines: IPolyline[] = [];

    static $inject = ["schedulingService", "plannedRouteMapService"];

    constructor(
        private readonly schedulingService: SchedulingService,
        private readonly plannedRouteMapService: PlannedRouteMapService) {
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {

        if (!this.veriMap.mapInitialised) {
            return;
        }
        
        if (onChangesObj["route"] && this.route) {
            this.updatePlannedVisits(this.route);
            this.updateRouteDisplay();
            this.fitMap();
        }

        if (onChangesObj["unplannedStops"] || onChangesObj["showUnplannedStops"]) {
            this.updateMarkerIcons();
        }

        if (onChangesObj["markers"] && this.markers) {
            this.fitMap();
        }

        if (onChangesObj["selectedStop"]) {
            this.fitMap();
        }
    }

    $onInit(): void {
        this.veriMap.mapInitialisedPromise.then(map => {
            this.updateRouteDisplay();
            this.fitMap();
        });
    }

    updateRouteDisplay() {
        //
        this.polylines = [];
        if (this.routeVisits) {

            this.routeVisits.forEach((routeStop, index) => {

                const polyline = this.createVisitPolyline(routeStop, index);

                if (polyline) {
                    this.polylines.push(polyline);
                }
            });

            this.updateMarkerIcons();
        }
    }
    private updatePlannedVisits(route: IPlannedRoute): void {
        if (!route) {
            this.routeVisits = null;
            return;
        }

        this.routeVisits = route.PlannedVisits;
    }

    private createVisitPolyline(routeVisit: IPlannedRouteVisit, index: number): IPolyline {
        if (!routeVisit.LinePoints || routeVisit.LinePoints.length === 0) {
            const previousStop = this.routeVisits[index - 1];

            if (!previousStop) {
                return null;
            }
        }


        return this.schedulingService.createPolylineForVisit(routeVisit, index);
    }

    createPolyline(routeVisit: IPlannedRouteVisit): IPolyline {

        const latLngArray: google.maps.LatLng[] = [];

        routeVisit.LinePoints.forEach(x => {
            latLngArray.push(new google.maps.LatLng(x[0], x[1]));
        });

        const polylineOptions: IPolylineOptions = {
            stroke: {
                color: "#000000",
                weight: 4,
                opacity: 1
            }
        }
        
        const polyline: IPolyline<IPlannedRouteVisit> = {
            id: this.polylines.length,
            path: latLngArray,
            options: polylineOptions,
            data: routeVisit
        };

        return polyline;
    }

    private updateMarkerIcons() {
        this.markers = [];

        if (!this.routeVisits) {
            return;
        }
        
        const options = {
            showEveryStop: this.route.PlannedVisits?.length <= 10,
            showUnplannedStops: this.showUnplannedStops,
            showPlannedStops: true,
            bypassStatus: this.scheduleMode,
            route: this.route,
            unplannedStops: this.unplannedStops
        };

        this.markers = this.plannedRouteMapService.createMapMarkersForRoute(options);
    }

    private getRouteStopCoords(visit: IPlannedRouteVisit): google.maps.LatLngLiteral {

        if (visit.RouteStopLocationJson) {
            const routeStopLocation = JSON.parse(visit.RouteStopLocationJson);
            return {
                lat: routeStopLocation.Latitude,
                lng: routeStopLocation.Longitude
            }
        }
        else if (visit.GeocodedAddress) {
            return {
                lat: visit.GeocodedAddress.CenterPoint.Latitude,
                lng: visit.GeocodedAddress.CenterPoint.Longitude
            }
        }
        else if (visit.Geofence) {
            return {
                lat: visit.Geofence.Latitude,
                lng: visit.Geofence.Longitude
            }
        }
    }

    private fitMap() {
        if (this.fit === false || (this.polylines.length === 0 && this.markers.length === 0)) {
            return;
        }

        if (this.selectedVisit) {
            const coords = this.getRouteStopCoords(this.selectedVisit);

            this.veriMap.fitMap([new google.maps.LatLng(coords)]);
            this.veriMap.getMap().setZoom(12);
        }
        else if (this.polylines.length > 0) {
            let latLngs: google.maps.LatLng[] = [];

            this.polylines.forEach(line => {
                latLngs = latLngs.concat(line.path);
            });

            this.veriMap.fitMap(latLngs);
        }
        else {

            this.veriMap.fitMap(this.markers.map(m => new google.maps.LatLng(m.options.position)));
        }
    }
}

export class VeriMapRouteComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    require: { [index: string]: string; };

    constructor() {
        this.bindings = {
            route: "<",
            actualJourneys: "<?",
            scheduleMode: "<?",
            selectedVisit: "<?",
            unplannedStops: "<?",
            showPlannedRoute: "<?",
            showActualRoute: "<?",
            showUnplannedStops: "<?",
            fit: "<"
        };

        this.require = {
            veriMap: "^veriMap"
        };

        this.controller = VeriMapRouteComponentController;
        this.template = require("./veriMapRoute.html");
    }
}
